import {parsePhoneNumber} from './../../general/PhoneHelper.js';
import {asyncValidateAll} from "../CheckoutUtil";


const verifyPhoneNumber = ( inputEl, countryId ) => {

	// No Input - No check.
	// Skip this step and return true.
	if ( ! inputEl ) {
		return true;
	}

	// Return Promise for Async Handling.
	return new Promise( ( resolve, reject ) => {

		// Get Values.
		const phone = inputEl.value;

		// Check Phone Value.
		if ( typeof phone === 'undefined' || !phone || !phone.length ) {
			//checkaddress(event, form);
			resolve( true );
			return true;
		}

		// Get libPhoneNumber.
		parsePhoneNumber( phone, countryId )
			.then( ( lib ) => {
				const parsed = lib.getNumber();

				if ( parsed && parsed.isValid() ) {
					// Update phone number with normalised format and resolve.
					inputEl.value = parsed.formatInternational();
					resolve( true );
				} else {
					// Reject Promise and mark Phone Number Field.
					reject( inputEl.closest( '.input_row, .o-field' ) );
				}
			} );
	} ).catch( inputRowEl => {

		if ( inputRowEl instanceof HTMLElement ) {

			const messageEl = inputRowEl.querySelector( '.input_row_message, .o-field__message' );
			inputEl.setCustomValidity( inputRowEl.defaultErrorMessage || messageEl.innerText || 'Ungültige Telefonnummer!' );
			inputEl.checkValidity();
			inputEl.dispatchEvent( new CustomEvent( 'validated.acl', { bubbles: true } ) );

		} else {
			console.error( inputRowEl );
		}

		return false;
	} );
};


const verifyPhoneNumbers = ( inputEls, countryId ) => {

	// Allow multiple phone numbers.
	const promises = [];
	Array.from( inputEls ).forEach( ( inputEl ) => {
		promises.push( verifyPhoneNumber( inputEl, countryId ) );
	} );

	// Return true when all promises resolve truthy, else we return false.
	return asyncValidateAll( promises );
};

window.verifyPhoneNumber = verifyPhoneNumbers;
export default verifyPhoneNumbers;
